module.exports = __webpack_public_path__ + "img/pokemon-logo.3c1566b2.jpg";